"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FuseSidebarModule {
}
exports.FuseSidebarModule = FuseSidebarModule;
